<template>
  <main>
    <PageIntro
      :heading="'Your <span>' +configStrings.productName + '</span> account'"
      :body="'<p>Your membership has been created, you must now click the verification link contained within an email sent to the email address that you used during the registration.</p>'" /> 
    <FooterShout :type="'register'"/>
  </main>
</template>

<script>
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      PageIntro,
      FooterShout
    }
  }
</script>
